const routes = [
  {
    path: '',
    meta: {
      requestedTab: '',
    },
  }, {
    path: 'video',
    component: 'ProfileSectionPage/CommonVideoWrapper.vue',
    meta: {
      requestedTab: 'video',
      enable({ user, permissions }) {
        return user.profile.hasFilms;
      },
    },
  }, {
    path: 'likes',
    component: 'ProfileSectionPage/CommonVideoWrapper.vue',
    meta: {
      requestedTab: 'likes',
      enable({ user, permissions }) {
        const isSelf = permissions.isOwner && !permissions.viewAsOther;
        return user.profile.settings.showLikes || isSelf;
      },
    },
  }, {
    path: 'playlists',
    component: 'ProfileSectionPage/Playlists/index.ts.vue',
    meta: {
      requestedTab: 'playlists',
      enable: true,
    },
    children: [{
      path: '',
      component: 'ProfileSectionPage/Playlists/PlaylistsView/index.ts.vue',
      meta: {
        requestedTab: 'playlists',
        name: 'playlists',
      },
    }, {
      path: ':collectionId',
      component: 'ProfileSectionPage/Playlists/PlaylistView.ts.vue',
      props: true,
      meta: {
        requestedTab: 'playlists',
        name: 'playlist',
      },
    }],
  }, {
    path: 'watch-later',
    component: 'ProfileSectionPage/CommonVideoWrapper.vue',
    meta: {
      requestedTab: 'watch-later',
      enable({ user, permissions }) {
        return permissions.isOwner && !permissions.viewAsOther;
      },
    },
  },
];

export default routes;
